import styled from "styled-components";
import { Modal as AntModal, Button as AntButton } from "antd";
import { SpinCongratModalIcon, PMRewardBg } from '@assets';


export const Modal = styled(AntModal)`
	/* position: relative; */
	.ant-modal-content {
		padding-top: 16px !important;
		border: none !important;
		width: 340px !important;
		box-shadow: none !important;
		background-color: #fff !important;
	}
	@media screen and (max-width: 350px) {
		width: 265px !important;
		.ant-modal-content {
			width: 265px !important;
		}
	}
`;

export const ModalTitle = styled.p`
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: 32px; /* 145.455% */

	background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%);
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	@media screen and (max-width: 413px) {
		font-size: 18px;
		font-weight: 500;
	}
`;

export const ModalLabel = styled.p`
	color: #2A2A2A;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 26px; /* 162.5% */

	margin-top: 8px;
	@media screen and (max-width: 413px) {
		font-size: 12px;
		line-height: 15px;
	}
`;

export const AmountWrapper = styled.div`
	color: #D66700;
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: 32px; /* 145.455% */

	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 48px;

	background-image: url(${PMRewardBg});
	background-size: cover;

	margin-top: 20px;
	@media screen and (max-width: 413px) {
		font-size: 18px;
		line-height: normal;
	}
`;

export const OkWrapper = styled(AntButton)`
	width: 100%;
	margin: 24px auto 0;
	height: 54px;

	cursor: pointer;
	@media screen and (max-width: 413px) {
		margin-top: 15px;
		font-weight: 600;
		font-size: 17px;
		line-height: 20px;
	}
`;

export const ExpiredText = styled.div`
	color: var(--color-inverse, #2A2A2A);
	text-align: center;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px; /* 171.429% */
	width: 100%;
	margin: 12px auto 0;
	@media screen and (max-width: 413px) {
		font-size: 12px;
		font-weight: 600;
		line-height: 15px;
	}
`;

export const Icon = styled(SpinCongratModalIcon)``